import http from "../../../api/apiClient";
import { childrenFromFamilies } from "../utils/normalizeParentMergeData";

const asArray = (data) =>
  Array.isArray(data) ? data : (data?.content ?? data?.items ?? data?.data ?? []);

export const loadParentMergeCandidate = async (parentId) => {
  const [parentResponse, familiesResponse] = await Promise.all([
    http.get(`/parents/${parentId}`),
    http.get("/families", { params: { parentId } }),
  ]);
  const families = asArray(familiesResponse.data);
  return {
    parent: parentResponse.data,
    families,
    children: childrenFromFamilies(families),
  };
};

export const mergeParents = async ({
  targetParentId,
  sourceParentId,
  mergedParent,
}) => {
  const { data } = await http.post("/parents/merge", {
    targetParentId,
    sourceParentId,
    mergedParent,
  });
  return data;
};

